import { safeUrl } from "./appData";
export const hasJobBank = user => Boolean(user?.stripeConnectedAccountId || user?.paystackSubaccountCode);
export const jobIsOpen = job => job?.status === "active" && !job?.hiredApplicantId && !["pending", "rejected"].includes(job?.approvalStatus);
export function jobDay(value) {
  if (value === undefined || value === null || value === "") return "";
  const date = new Date(typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value + "T00:00:00" : value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {day:"numeric", month:"short", ...(date.getFullYear() !== new Date().getFullYear() ? {year:"numeric"} : {})});
}
export function jobRange(start, end) {
  const first = jobDay(start), last = jobDay(end);
  if (!first || !last) return first || last;
  return first === last ? first : first + " to " + last;
}
export function jobBudget(payRate, exchangeRate) {
  const value = String(payRate ?? "").trim();
  const amount = parseFloat(value.replace(/^(?:ZAR|USD)/i, "").replace(/[R$,\s]/g, ""));
  if (!Number.isFinite(amount) || amount <= 0) return 0;
  // Native app treats R-prefixed values as ZAR and legacy bare/$ values as USD.
  return /^R|^ZAR/i.test(value) ? amount : amount * (Number(exchangeRate) || 0);
}
export const jobRand = value => "R" + Number(value).toLocaleString("en-ZA", {maximumFractionDigits:2});
export const creatorSplit = amount => {
  const fee = Math.round(amount * 0.07 * 100) / 100;
  return {fee, payout: Math.round((amount - fee) * 100) / 100};
};
export function jobReferences(job) {
  const raw = job?.references;
  return (Array.isArray(raw) ? raw : Object.values(raw || {}))
    .filter(item => safeUrl(item?.url)).slice(0,3)
    .map(item => ({...item, url:safeUrl(item.url), platform:item.platform || new URL(item.url).hostname.replace(/^www\./,"")}));
}
export function buildJobShare(job, jobId, sender, note = "", now = Date.now()) {
  if (!jobId || !sender?.uid) throw new Error("Missing share details.");
  const name = sender.name || sender.displayName || "A friend";
  const title = job.title || "Job";
  // Job metadata gives both clients an in-app card; text remains readable by older clients.
  const text = [note.trim().slice(0,280), `${name} thought you'd be right for "${title}".`, `https://zylen.app/#/job/${jobId}`].filter(Boolean).join("\n\n");
  const message = {type:"text", text, senderId:sender.uid, senderName:name, seen:false, timestamp:now, jobId, jobTitle:title, jobEvent:"shared"};
  const extra = {senderAvatar:sender.profilePic || sender.photoURL, jobRole:job.role || job.niche, jobLocation:job.location || job.city, jobPayRate:job.payRate ?? job.budget, jobImageUrl:job.imageUrl || job.hostProfilePic};
  Object.entries(extra).forEach(([key,value]) => { if (value !== undefined && value !== null && String(value).trim()) message[key] = String(value); });
  return message;
}

